import { useContext } from "react";
import UserWalletContext from "../contexts/walletContext";
import { config } from "../config";

function BtnMetamask() {
  const { userWallet, btnText, clickHandler } = useContext(UserWalletContext);
  const userAccount = userWallet.account || "";
  return (
    <div className="action">
      {btnText.length > 0 ? (
        <button
          className={`hover-zoom zoom-shadow ${btnText.replace(/ /g, "_")}`}
          onClick={clickHandler}
        >
          {btnText}
        </button>
      ) : (
        <>
          <div>
            <span className="user-address" title={userAccount}>
              {userAccount.slice(0, 2 + 5) + "…" + userAccount.slice(-5)}
            </span>
          </div>
          <div style={{ marginTop: "10px" }}>
            <button
              className={`hover-zoom zoom-shadow ${btnText.replace(/ /g, "_")}`}
              onClick={() => {
                window.open(
                  `https://${config.openseaDomain}/${userAccount}?search[collections][0]=${config.openseaCollectionName}`,
                  "_blank"
                );
              }}
            >
              View Your Frogs Over Dogs
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default BtnMetamask;
